import { render, staticRenderFns } from "./vue.vue?vue&type=template&id=4bb8f22f&scoped=true&"
import script from "./vue.vue?vue&type=script&lang=js&"
export * from "./vue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb8f22f",
  null
  
)

export default component.exports